import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import CommonCardFooter from "../Common/CommonCardFooter";
import { WithoutBordersStyles } from "../../../../Constant";
import { WITHOUT_BORDER } from "../../../../Data/FormControl/MegaOptions";
import WithoutBordersStyleForm from "./WithoutBordersStyleForm";

const WithoutBordersStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={WithoutBordersStyles} span={WITHOUT_BORDER} />
        <CardBody>
          <WithoutBordersStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="warning" color2="light-warning" btn2Class="list-light-warning"/>
      </Card>
    </Col>
  )
};

export default WithoutBordersStyle;
